import React from 'react';
import type { InsuranceSummary } from '../../../dtos/patientmr/insurance.dto';
import { lacksActivePrimary, payerBadgeClass, payerBadgeLabel } from './insuranceDisplay';

interface PayerBadgesProps {
  /** Patient insuranceSummary; nothing renders until the server has computed one */
  summary?: InsuranceSummary | null;
  className?: string;
}

/**
 * Payer badges for the patient list and header (PAT-08 / REQ-INS-07): one badge per payer in
 * effect today ("+Medicaid" for a secondary), and a red "No active primary" badge.
 */
const PayerBadges: React.FC<PayerBadgesProps> = ({ summary, className = '' }) => {
  if (!summary) return null;
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`} data-testid="payer-badges">
      {(summary.activePayers || []).map(p => (
        <span
          key={`${p.cobOrder}-${p.coverageType}-${p.payerName}`}
          className={`px-1.5 py-0.5 rounded text-xs font-medium ${payerBadgeClass(p.coverageType)}`}
          title={`${p.cobOrder}: ${p.payerName}`}
        >
          {payerBadgeLabel(p)}
        </span>
      ))}
      {lacksActivePrimary(summary) && (
        <span className="px-1.5 py-0.5 rounded text-xs font-semibold bg-red-100 text-red-800 border border-red-300">
          No active primary
        </span>
      )}
    </span>
  );
};

export default React.memo(PayerBadges);
